/*jslint node: true, browser: true*/

"use strict";

var ko = require("pli/knockout");

//-------------------------------------------
function createErrorsSummaryObservable(pages) {
    /// <summary>
    /// Create dependable observable for errors tool tip
    /// </summary>
    /// <param name="pages">The array to fire if allowed</param>
    if (Array.isArray(pages) && pages.map(function (item) {
            if (item) {
                if (!item.page || !item.page.title) {
                    throw new Error("item.page with title property is required");
                }
                if (!item.errors || !ko.isObservable(item.errors)) {
                    throw new Error("item.errors observable is required");
                }
            }
        })) {
        return ko.computed(function () {
            return pages.filter(function (item) {
                return item && item.errors() > 0;
            }).map(function (item) {
                return { name: item.page.title, hash: item.page.activationHash, count: item.errors() };
            });
        });
    }
}

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Export
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = {
    createErrorsSummaryObservable: createErrorsSummaryObservable
};



//////////////////
// WEBPACK FOOTER
// ./app/document/pliUtils.js
// module id = 572
// module chunks = 49